<div class="nxe-list" nxeDragDrop (dragging)="dragging = $event">
  <div class="nxe-list-drag" [ngClass]="{ dragging: dragging }"></div>
  <div class="nxe-list-backpad" (click)="emptySpaceClick()"></div>
  <div class="nxe-list-container drop-list_ pp0" [id]="parentItem.id+''" [class.dragging-element]="draggingelement"
    cdkDropList [cdkDropListConnectedTo]="connectedIds" cdkDropListSortingDisabled>

    <!-- Parent folder dropzone (se presente) -->

    <div class="nxe-list-wrapper table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>{{'Name' | translate}}</th>
            <th>{{'Type' | translate}}</th>
            <th>{{'Size' | translate}}</th>
            <th>{{'Last Modified' | translate}}</th>
            <th>{{'filemanager.rag.status_column' | translate}}</th>
            <th>{{'filemanager.rag.processing_column' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <!-- Riga per risalire alla directory precedente -->
          @if(parentObj) {
          <tr class="drop-list-folder" [ngClass]="{ 'nxe-list-row-selected': isSelected(parentObj) }"
          (dblclick)="open($event, parentObj)"
          (click)="select($event, parentObj)"

          >
            <td colspan="6">
              <div class="drop-list-folder">
                <div class="drop drop-list drop-zone pp1" [id]="parentObj.id+''" cdkDropList
                  [cdkDropListData]="parentObj" [cdkDropListConnectedTo]="connectedButMe(parentObj)"
                  (cdkDropListDropped)="onDragDropParent($event,parentObj)">
                  <!-- Parent folder dropzone -->
                </div>
                <div class="nxe-icons-wrapper "
                  [id]="'parentDroplist_'+parentObj.id" cdkDrag [cdkDragDisabled]="isSelected(parentObj)">
                  <div class="nxe-icons-wrapper-inner" [ngClass]="{ 'nxe-icon-selected': isSelected(parentObj) }"
                    [title]="parentObj.name">
                    <div class="nxe-icons-icon">
                      <i-tabler class="icon-32 icon-dir" name="dots"></i-tabler>
                    </div>
                    <div class="nxe-icon-text">{{ parentObj.name }}</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          }

          @for (item of items; track $index) {
            @if (item.isLeaf) {
            <!-- File draggabile -->
            <tr class="drag-item-leaf" [ngClass]="{ 'nxe-list-row-selected': isSelected(item) }"
            (dblclick)="open($event, item)"
             (click)="select($event, item)"
             (cdkDragStarted)="onDragStart($event, item)"
              [cdkDragData]="selectedNodes" cdkDrag
              [id]="item.id"
            >
              <td>
                <div class="drag-item nxe-icons-wrapper">
                  <div class="nxe-icons-wrapper-inner"
                    [title]="item.name">
                    <div class="nxe-icons-icon" cdkDragHandle>
                      @if (item.data['content_type'] === 'application/pdf') {
                      <i-tabler class="icon-32 icon-file" name="file-type-pdf"></i-tabler>
                      }
                      @if (item.data['content_type'] === 'image/jpg' ||
                      item.data['content_type'] === 'image/jpeg') {
                      <i-tabler class="icon-32 icon-file" name="file-type-jpg"></i-tabler>
                      }
                      @if (item.data['content_type'] === 'image/png') {
                      <i-tabler class="icon-32 icon-file" name="file-type-png"></i-tabler>
                      }
                    </div>
                    <div class="nxe-icon-text">{{ item.name }}</div>
                  </div>
                  <div *cdkDragPreview>
                    @for(node of selectedNodes; track $index){
                      <div class="drag-item-preview">
                        <i-tabler class="icon-24 icon-file" name="file"></i-tabler>
                        <div class="nxe-icon-text">{{ node.name }}</div>
                      </div>
                    }
                  </div>
                  <div class="nxe-list-placeholder" *cdkDragPlaceholder></div>
                </div>
              </td>
              <td>
                @if (item.data['type'] === 'file') {
                {{ item.data['content_type'] }}
                }
              </td>
              <td>
                @if (item.data['dimension_file'] > 0) {
                {{ item.data['dimension_file'] }} KB
                }
              </td>
              <td>
                {{ item.data['updated_at'] | date: 'dd-MM-yyyy, HH:mm:ss' }}
              </td>
              <td>
                @if (isRagSupported(item)) {
                  <span class="rag-badge" [ngClass]="'rag-badge--' + ragStatusClass(item)">
                    @if (isRagProcessing(item)) {
                      <i-tabler class="icon-16 rag-spin" name="loader-2"></i-tabler>
                    }
                    {{ ragStatusLabel(item) }}
                  </span>
                } @else {
                  <span class="rag-badge rag-badge--na">—</span>
                }
              </td>
              <td>
                @if (isRagSupported(item)) {
                  <div class="rag-actions" (click)="$event.stopPropagation()">
                    <button type="button" class="rag-btn rag-btn--send"
                      [disabled]="!canSendToRag(item)"
                      [title]="ragSendLabel(item)"
                      (click)="sendToRag($event, item)">
                      <i-tabler class="icon-16" name="brain"></i-tabler>
                    </button>
                    <button type="button" class="rag-btn rag-btn--remove"
                      [disabled]="!canRemoveFromRag(item)"
                      [title]="ragRemoveLabel()"
                      (click)="removeFromRag($event, item)">
                      <span class="brain-off">
                        <i-tabler class="icon-16" name="brain"></i-tabler>
                        <i-tabler class="icon-16 slash" name="slash"></i-tabler>
                      </span>
                    </button>
                  </div>
                }
              </td>
            </tr>
            }

            @if (!item.isLeaf) {
            <!-- Cartella con dropzone -->
            <tr class="drop-list-folder"
            [ngClass]="{ 'nxe-list-row-selected': isSelected(item) }"
            (dblclick)="open($event, item)"
            (click)="select($event, item)"
            (cdkDragStarted)="onDragStart($event, item)"
            [cdkDragData]="selectedNodes" cdkDrag
            [id]="'folder'+item.id"
            >
              <!-- Riga della cartella draggabile -->
              <td colspan="3">
                <div class="drop-list-folder">
                  <div class="nxe-icons-wrapper ">
                    <div class="nxe-icons-wrapper-inner"
                      [title]="item.name">
                      <div class="nxe-icons-icon" cdkDragHandle>
                        <i-tabler class="icon-32 icon-dir" name="folder-filled"></i-tabler>
                      </div>
                      <div class="nxe-icon-text">{{ item.name }}</div>
                    </div>
                      <div *cdkDragPreview>
                        @for(node of selectedNodes; track $index){
                          <div class="drag-item-preview">
                            <i-tabler class="icon-24 icon-file" name="folder-filled"></i-tabler>
                            <div class="nxe-icon-text">{{ node.name }}</div>
                          </div>
                        }
                      </div>
                      <div class="nxe-list-placeholder" *cdkDragPlaceholder></div>
                  </div>
                  <div class="drop drop-list drop-zone pp3" [id]="item.id+''"
                  cdkDropList
                  [cdkDropListData]="item"
                  [cdkDropListConnectedTo]="connectedButMe(item)"
                  (cdkDropListDropped)="onDragDrop($event,item)">
                    <!-- Child folder dropzone -->
                  </div>
                </div>
              </td>
              <td>
                {{ item.data['updated_at'] | date: 'dd-MM-yyyy, HH:mm:ss' }}
              </td>
              <td></td>
              <td></td>
              <!-- Drop zone per la cartella -->

            </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
